import {AppFunction} from "../misc/types";
import {SessionsView} from "../views/sessions";
import View from "../framework/view";

export class SessionsFunction extends AppFunction {

    readonly v : View;

    constructor(admin: boolean) {
        super();
        this.v = new SessionsView(this);
    }

    view() {
        return this.v;
    }
    url() {
        return "/sessions";
    }

}

